import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];
  static values = {
    autoClose: { type: Boolean, default: true },
    closeOnOutside: { type: Boolean, default: true },
  };

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape);
    // Clean up backdrop click listener if it exists
    if (this.dialogTarget && this.handleBackdropClick) {
      this.dialogTarget.removeEventListener("click", this.handleBackdropClick);
    }
  }

  show() {
    this.dialogTarget.showModal();
    document.addEventListener("keydown", this.handleEscape);

    // Add backdrop click listener if enabled
    if (this.closeOnOutsideValue) {
      this.boundBackdropHandler = this.handleBackdropClick.bind(this);
      this.dialogTarget.addEventListener("click", this.boundBackdropHandler);
    }

    // Focus management for accessibility
    this.dialogTarget.focus();
    // Add ARIA attributes for better accessibility
    this.dialogTarget.setAttribute("aria-modal", "true");
  }

  close() {
    this.dialogTarget.close();
    document.removeEventListener("keydown", this.handleEscape);
    // Clean up backdrop click listener
    if (this.boundBackdropHandler) {
      this.dialogTarget.removeEventListener("click", this.boundBackdropHandler);
      this.boundBackdropHandler = null;
    }
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.autoCloseValue) {
      this.close();
    }
  }

  handleBackdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close();
    }
  }

  // Action method for opening specific modals by ID
  openModal(event) {
    console.log(
      `Triggering open modal from ${event.currentTarget.dataset.modalId}`
    );
    event.preventDefault();
    const modalId = event.currentTarget.dataset.modalId;
    const modalElement = document.getElementById(modalId);

    if (modalElement) {
      const controller = this.application.getControllerForElementAndIdentifier(
        modalElement,
        "modal"
      );
      if (controller) {
        controller.show();
      }
    } else {
      console.error(`Modal Element not found for ${modalId}`);
    }
  }

  closeAfterSubmit() {
    // Add a small delay to allow form submission to process
    setTimeout(() => {
      this.close();
    }, 100);
  }
}
